import { URL_ARCHIVE_CONTACT } from 'constants/urls';

const archiveContactApi = async (contactId) => {
	const options = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		body: JSON.stringify({ id: contactId }),
	};
	const res = await fetch(URL_ARCHIVE_CONTACT, options);
	const data = await res.json();

	return data;
};

export default archiveContactApi;